import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, ChevronDown, BookOpen, Sprout } from "lucide-react";
import { Link } from "react-router-dom";
import { heroStats, builtFor, brand } from "../mock";

const Hero = () => {
  return (
    <section
      id="top"
      className="relative pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black via-[#04181a] to-black" />
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, #2dd4bf 0%, transparent 40%), radial-gradient(circle at 80% 60%, #14b8a6 0%, transparent 45%)",
        }}
      />
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)",
          backgroundSize: "56px 56px",
          maskImage:
            "radial-gradient(ellipse at center, black 40%, transparent 75%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-center mb-6">
          <div className="inline-flex items-center gap-2 bg-teal-500/10 border border-teal-400/30 text-teal-200 px-4 py-1.5 rounded-full text-xs tracking-wide">
            <Sprout className="w-3.5 h-3.5" />
            <span>{brand.verse}</span>
          </div>
        </div>

        <div className="flex items-center justify-center mb-8">
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[11px] md:text-xs tracking-wide uppercase text-white/50">
            <span>Built for</span>
            {builtFor.map((t, i) => (
              <React.Fragment key={t}>
                <span className="text-white/70">{t}</span>
                {i < builtFor.length - 1 && (
                  <span className="text-teal-400">·</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        <h1 className="text-center font-semibold tracking-tight text-white text-[40px] leading-[1.05] sm:text-5xl md:text-6xl lg:text-7xl max-w-5xl mx-auto">
          Where faith{" "}
          <span className="italic text-teal-300 font-serif font-normal whitespace-nowrap">
            bears fruit
          </span>
          .
        </h1>

        <p className="mt-6 md:mt-8 text-center text-white/70 text-base md:text-xl max-w-2xl mx-auto">
          One connected app for your community, your communication, your
          biblical finance journey, and the funding to start what God&apos;s
          calling you to build.
        </p>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button
            className="bg-teal-500 hover:bg-teal-400 text-black font-semibold h-12 px-6 rounded-md"
            onClick={() =>
              document
                .getElementById("cta")
                ?.scrollIntoView({ behavior: "smooth" })
            }
          >
            Plant your Hub free
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
          <Link to="/finance-course">
            <Button
              variant="outline"
              className="bg-transparent border border-white/20 text-white hover:bg-white/5 hover:text-teal-300 h-12 px-6 rounded-md"
            >
              <BookOpen className="w-4 h-4 mr-2" />
              Explore the finance course
            </Button>
          </Link>
        </div>

        <div className="mt-14 flex justify-center">
          <div className="flex flex-col items-center gap-1 text-white/40 text-xs">
            <span>Scroll</span>
            <ChevronDown className="w-4 h-4 animate-bounce" />
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-xl overflow-hidden border border-white/10">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="bg-black/60 backdrop-blur-sm p-6 md:p-8 hover:bg-black/40 transition-colors"
            >
              <div className="text-4xl md:text-5xl font-semibold text-teal-300 tracking-tight">
                {s.value}
              </div>
              <div className="mt-2 text-white font-medium text-sm md:text-base">
                {s.label}
              </div>
              <div className="mt-1 text-white/50 text-xs md:text-sm">
                {s.sub}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
